import React from 'react';
import { Box, FlexForm, useResponsive } from '@common-fe/common-fe';
import styled, { css } from 'styled-components';

import theme from '@/styles/theme';

import { Patient } from '../usePatients.query';
import { useRelationshipsTypesQuery } from '../useRelationshipsTypes.query';

import usePatientFields from './usePatientFields';

interface WrapperProps {
  $isMobile?: boolean;
}
const Wrapper = styled(Box)<WrapperProps>`
  ${({ $isMobile }) => {
    if ($isMobile) {
      return css`
        input[data-testid$='_ssn_mask-text-input'] {
          font-feature-settings: 'calt' 0;
        }
        & > div:first-child {
          flex: 1 1 0%;
          /* Your styles here */
        }
        & form {
          display: flex;
          flex-direction: column;
          justify-content: between;
          flex: 1 1 0%;
        }
        & form > div:nth-of-type(2) {
          flex: 1 1 0%;
          display: flex;
          align-items: end;
          justify-content: end;
        }
      `;
    }
    return css`
      input[data-testid$='_ssn_mask-text-input'] {
        font-feature-settings: 'calt' 0;
      }
    `;
  }}
`;
interface Props {
  onSubmit: (value: Patient) => void;
  patientName?: string;
  defaultValue?: Partial<Patient>;
  footer?: React.ReactNode;
}

const PatientForm: React.FC<Props> = ({ patientName, onSubmit, defaultValue, footer }) => {
  const { isMobile } = useResponsive();
  const { formattedRelationshipsTypes } = useRelationshipsTypesQuery();
  const fields = usePatientFields({
    relationshipTypes: formattedRelationshipsTypes,
    defaultValue,
    patientName,
  });

  return (
    <Wrapper $isMobile={isMobile} height="100%" style={{ flex: 1 }}>
      <FlexForm
        fields={fields}
        contentStyles={
          isMobile
            ? {
                ...theme.mobileFormFieldsEdging,
                flex: 0,
              }
            : theme.formFieldsEdging
        }
        paddingless
        isNarrowLabelMode
        editMode
        onSubmit={onSubmit}
        footer={footer}
      />
    </Wrapper>
  );
};

export default PatientForm;
